
export const PricingTable = () => {
    return (
        <div className="row Pricing mt-4 mb-4">
            <h2 className="text-center mb-4 mt-4">
                We Offer a varitey of plans to suit your needs and budgets
            </h2>
            <div className="col-lg-3 mt-5 col-md-6 col-sm-6 d-flex flex-wrap">
                <table className="Titanium table-bordered">
                    <tbody>
                        <tr>
                            <th>Eligible Vehicles:</th>
                        </tr>
                        <tr>
                            <td>
                                <h5>Maximum inception mileage: 100%</h5>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Brake hydraulic systems
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> cover and release plate
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> water pump
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Drive belts &amp; tensioners
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Other ECUs (computers)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Starter motor and alternator
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Fuel System
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Camshaft systems
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Air conditioning systems{" "}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Brake hydraulic systems
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> cover and release plate
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> water pump
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Drive belts &amp; tensioners
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Other ECUs (computers)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Starter motor and alternator
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Fuel System
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-check" /> Camshaft systems
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 d-flex flex-wrap">
                <div className="paltinum_span">
                    <span>A</span>
                </div>
                <table className="Platinum  table-bordered">
                    <tbody>
                        <tr>
                            <th style={{ backgroundColor: "gold" }}>
                                Cover for cars 3 years and older coming out of the
                                manufacturer’s guarantee
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <h5 style={{ color: "gold" }}>60%</h5>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "gold" }} className="fa fa-check" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 d-flex flex-wrap">
                <div className="Gold_span">
                    <span>B</span>
                </div>
                <table className="Gold table-bordered">
                    <tbody>
                        <tr >
                            <th style={{ backgroundColor: "silver" }}>Essential cover for cars 5 years and older</th>
                        </tr>
                        <tr>
                            <td>
                                <h5 style={{ color: "silver" }}>100%</h5>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "silver" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 d-flex flex-wrap">
                <div className="paltinum_span">
                    <span>C</span>
                </div>
                <table className="Silver table-bordered">
                    <tbody>
                        <tr>
                            <th style={{ backgroundColor: "#878681" }}>Cars 10 years and older</th>

                        </tr>
                        <tr>
                            <td>
                                <h5 style={{ color: "#878681" }}>120%</h5>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i className="fa fa-remove" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <i style={{ color: "#878681" }} className="fa fa-check" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    )
}
